export const DETAILS_DATA_ACTION = 'DETAILS_DATA_ACTION';
export const DETAILS_DATA_SUCCESS = 'DETAILS_DATA_SUCCESS';
export const FETCH_DETAILS_DATA_ERROR='FETCH_DETAILS_DATA_ERROR';
export const UPDATE_TASK_ROLES='UPDATE_TASK_ROLES';
export const UPDATE_TASK_ROLES_SUCCESS='UPDATE_TASK_ROLES_SUCCESS';
export const GET_USER_ROLES='GET_USER_ROLES';
export const GET_USER_ROLES_SUCCESS='GET_USER_ROLES_SUCCESS';
export const GET_PREVIOUS_TASKS= 'GET_PREVIOUS_TASKS';
export const GET_PREVIOUS_TASKS_SUCCESS = 'GET_PREVIOUS_TASKS_SUCCESS';